export const LADDER_NAME_MAX_LENGTH = 60;
export const USER_NAME_MIN_LENGTH = 4;
export const USER_NAME_MAX_LENGTH = 30;
export const USER_MATCHES_DEFAULT_LIMIT = 15;
export const LADDER_MATCHES_DEFAULT_LIMIT = 15;
